import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_3701_4282)" }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11 1.48575C5.74543 1.48575 1.48575 5.74541 1.48575 11C1.48575 12.8421 2.00932 14.562 2.91576 16.019C4.10698 14.1845 5.90596 12.7802 8.02797 12.0924C6.88782 11.2056 6.15432 9.82064 6.15432 8.26456C6.15432 5.58835 8.32383 3.41885 11 3.41885C13.6763 3.41885 15.8458 5.58835 15.8458 8.26456C15.8458 9.82062 15.1123 11.2056 13.9722 12.0924C16.0942 12.7801 17.8933 14.1843 19.0844 16.0188C19.9907 14.5619 20.5142 12.8421 20.5142 11C20.5142 5.74541 16.2546 1.48575 11 1.48575ZM11.284 21.9964C17.2279 21.8458 22 16.9802 22 11C22 4.92486 17.0751 0 11 0C4.92487 0 0 4.92486 0 11C0 16.9563 4.73417 21.8069 10.6449 21.9944C10.7629 21.9981 10.8812 22 11.0001 22C11.095 22 11.1897 21.9988 11.284 21.9964ZM18.1244 17.3032C16.7328 14.8013 14.063 13.1108 11.0001 13.1108C7.93722 13.1108 5.26783 14.8012 3.87578 17.3032C5.54481 19.1878 7.94697 20.405 10.6323 20.5073C10.7543 20.5119 10.8769 20.5142 11.0001 20.5142C11.1489 20.5142 11.2969 20.5108 11.444 20.5041C14.0987 20.382 16.4713 19.1703 18.1244 17.3032ZM11 4.9046C9.14439 4.9046 7.64008 6.40891 7.64008 8.26456C7.64008 10.1203 9.14454 11.625 11.0001 11.625C12.8556 11.625 14.36 10.1204 14.36 8.26456C14.36 6.40891 12.8557 4.9046 11 4.9046Z",
        fill: "currentColor"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_3701_4282" }, [
        _createElementVNode("rect", {
          width: "22",
          height: "22",
          fill: "currentColor"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }